import { useQuery } from "@tanstack/react-query";
import {
  type GetLoyaltyPeriodsQueryResult,
  getLoyaltiesPeriods,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const LOYALTY_PERIODS_QUERY_KEY = "LOYALTY_PERIODS";

export const loyaltyPeriodsKeys = {
  all: [LOYALTY_PERIODS_QUERY_KEY],
};

export const useLoyaltyPeriodsQuery = () =>
  useQuery<GetLoyaltyPeriodsQueryResult>({
    queryKey: loyaltyPeriodsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getLoyaltiesPeriods()),
  });
